export default function ($rootScope, $http, $q) {

    var URL_BASE = '/webapi/classsearch/',
        selectedTerm = {},
        currentTerms = [],
        courses = {},
        classes = {};

    /**
     * Generic subscription function for pubsub syncing
     * @param {} scope 
     * @param {} event 
     * @param {} callback 
     * @returns {} 
     */
    function subscribe(scope, event, callback) {
        var handler = $rootScope.$on(event, callback);
        scope.$on('$destroy', handler);
    }

    /**
     * Get all currently timetabled terms and cache the result 
     * @returns {} 
     */
    function getTerms() {
        return $http.get(URL_BASE + 'GetCurrentTerms').then(function (result) {
            currentTerms = result.data.data;
            return result.data;
        });
    }

    /**
     * Get all courses for the currently selected term and cache the result to a local object using the termId as the key        
     * @returns {} 
     */
    function getCourses() {
        var promise;

        var termId = selectedTerm.id;

        if (!courses[termId]) {
            var url = URL_BASE + 'GetCourses?term=' + termId;
            promise = $http.get(url);
            promise.then(function (response) {

                response.data.data = response.data.data.sort(function (a, b) {
                    if (a.courseCode < b.courseCode) {
                        return -1;
                    }
                    if (a.courseCode > b.courseCode) {
                        return 1;
                    }
                    return 0;
                });
                courses[termId] = response.data;
                $rootScope.$emit('coursesChanged', response.data);
            });
        } else {
            promise = $q.when(courses[termId]);
            $rootScope.$emit('coursesChanged', courses[termId]);
        }
        return promise;
    }

    /**
     * Get the employee by id
     * @param {} emplId 
     * @returns {} 
     */
    function getEmployee(emplId) {
        return $http.get(URL_BASE + 'GetCoord?empl=' + emplId).then(function (result) {
            return result.data;
        });
    }

    /**
     * Get classes for the given term and course id, cache the result
     * Cached result will be returned if it exists.
     * @param {} termId 
     * @param {} courseId 
     * @returns {} 
     */
    function getClasses(courseId, termId) {

        var promise,
            term = termId || selectedTerm.id,
            key = term + '_' + courseId;

        if (!classes[key]) {
            var url = URL_BASE + 'GetClassMeetings?term=' + term + '&course=' + courseId;
            promise = $http.get(url);
            promise.then(function (response) {
                classes[key] = response.data.data;

            });
        } else {
            promise = $q.when(classes[key]);
        }
        return promise;
    }

    /**
     * 
     * @param {} data 
     * @returns {} 
     */
    function getValidatedCourseTerms(data) {
        return $http({
            method: 'POST',
            url: URL_BASE + 'VerifyCourseTerm',
            data: JSON.stringify(data)
        }).then(function (result) {
            return result.data;
        });
    }

    function getClassBySearchTerm(courseList, term) {
        var data = {
            termId: term || selectedTerm.id,
            CourseList: courseList
        };
        return $http({
            method: 'POST',
            url: URL_BASE + 'GetClassbySearchTerm',
            data: JSON.stringify(data)
        }).then(function (result) {
            return result.data;
        });
    }

    function getCourseDetails(courseId) {
        return $http.get(URL_BASE + 'GetCourseDetails?&course=' + courseId).then(function (result) {
            return result.data;
        });
    }

    function getCampus() {
        return $http.get(URL_BASE + 'GetCampus').then(function (result) {
            return result.data;
        });
    }

    function setSelectedTerm(term) {
        selectedTerm = currentTerms.filter(function (v) {
            return v.id === term.id || v.id === term; // term may be object or int
        })[0];

        getCourses();
        $rootScope.$emit('selectedTermChanged', selectedTerm);
    }

    /**
     * Get the selected term - this is not a promise and will return immediately
     * @returns {} 
     */
    function getSelectedTerm() {
        return selectedTerm;
    }

    /**
     * Return a 
     * @param {} query 
     * @param {} termId 
     * @returns {} 
     */
    function search(query, termId) {

        setSelectedTerm(termId);

        getCourses(termId)
            .then(function (r) {
                var c = r.data.data ? r.data.data : r.data,
                    resp = c.filter(function (v) {
                        return v.courseCode === query || v.fullDescription.toLowerCase().indexOf(query.toLowerCase()) !== -1;
                    });
                $rootScope.$emit('resultsChanged', resp);
            });
    }

    /**
     * Check for an inbound course in the query string, and submit a search if it exists
     */
    function checkParams(terms) {

        var course,
            i,
            keyValue,
            queryString = location.search.substr(1),
            params = queryString.split('&');

        for (i = 0; i < params.length; i++) {
            keyValue = params[i].split('=');

            if (keyValue.length && keyValue[0] === 'course') {
                course = keyValue[1];
            }
        }
        if (course) {

            // needs a term, but still returns everything, not sure why.
            setSelectedTerm(terms[0]);

            getCourseDetails(course).then(function (resp) {
                $rootScope.$emit('resultsChanged', !resp.data ? [] : resp.data.filter(function (v) {
                    return terms.indexOf(v.termId) !== -1;
                }));
            });
        }
    }

    /**
     * Check the provided item for any class instances which are not hidden by filters
     * @param {any} item
     * @param {any} filters
     */
    function checkForVisibleChildren(item, filters) {
        var keys = [];
        for (var f in filters) {
            if (!keys.hasOwnProperty(f)) {
                keys.push(f);
            }
        }

        item.hasVisibleChildren = false;

        for (var j = 0, m = item.classes.length; j < m; j++) {
            var hiddenByFilter = false,
                jClass = item.classes[j];

            for (var k = 0, n = keys.length; k < n; k++) {
                if (jClass.hasOwnProperty(keys[k] + 'Filter') && jClass[keys[k] + 'Filter'] === false ||
                    (jClass.enrolmentStatus !== 'O' && !$rootScope.showAll)) {
                    hiddenByFilter = true;
                }
            }
            jClass.hiddenByFilter = hiddenByFilter;
        }

        var visibleChildrenCount = item.classes.where(function (el) {
            return el.hiddenByFilter === false;
        }).length;

        if (visibleChildrenCount > 0) {
            item.hasVisibleChildren = true;
        }
        return item;
    }

    /* Expose a public API */
    return {
        subscribe: subscribe,
        getCourses: getCourses,
        search: search,
        getTerms: getTerms,
        getEmployee: getEmployee,
        getClasses: getClasses,
        getValidatedCourseTerms: getValidatedCourseTerms,
        getClassBySearchTerm: getClassBySearchTerm,
        getCourseDetails: getCourseDetails,
        getCampus: getCampus,
        getSelectedTerm: getSelectedTerm,
        setSelectedTerm: setSelectedTerm,
        checkParams: checkParams,
        checkForVisibleChildren: checkForVisibleChildren
    };
};